import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.operations.rack');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';


@Component({
 standalone: false,
 selector: 'wiz-page-kiera-operations-rack',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.operations.rack/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.operations-rack-view {
  color: #18181b;
  min-width: 0;
}

button,
select,
input {
  font: inherit;
}

.ops-page-header {
  display: flex;
  flex: none;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.ops-work-badge,
.ops-mode-badge,
.ops-state-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
}

.ops-work-badge {
  color: #ea580c;
  background: #fff7ed;
  padding: 4px 9px;
}

.ops-mode-badge {
  color: #4f46e5;
  background: #eef2ff;
  padding: 4px 9px;
}

.ops-mode-badge.is-detail {
  color: #1d4ed8;
  background: #eff6ff;
}

.ops-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
}

.ops-button {
  display: inline-flex;
  height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #fff;
  padding: 0 12px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  transition: 0.15s ease;
}

.ops-button:hover:not(:disabled) {
  border-color: #a5b4fc;
  background: #f8fafc;
  color: #4338ca;
}

.ops-button:disabled,
.ops-icon-group button:disabled,
.ops-zoom-group button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.ops-button.is-primary-outline {
  border-color: #6366f1;
  color: #4f46e5;
}

.ops-button.is-danger-outline {
  border-color: #fecaca;
  color: #dc2626;
}

.ops-button.is-danger-outline.is-active {
  background: #fef2f2;
  box-shadow: inset 0 0 0 1px #f87171;
}

.ops-button.is-compact {
  padding: 0 10px;
}

.ops-icon-group,
.ops-zoom-group {
  display: inline-flex;
  height: 36px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #fff;
}

.ops-icon-group button,
.ops-zoom-group button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: 0.15s ease;
}

.ops-icon-group button + button,
.ops-zoom-group button + button {
  border-left: 1px solid #e2e8f0;
}

.ops-icon-group button.is-active {
  color: #4f46e5;
  background: #eef2ff;
}

.ops-zoom-group span {
  min-width: 50px;
  text-align: center;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
}

.ops-filter-panel {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
  margin-bottom: 12px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.ops-filter-field {
  display: flex;
  min-width: 160px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px 9px;
  background: #fff;
}

.ops-filter-field > span,
.ops-zone-select > span {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.ops-filter-field select {
  width: 100%;
  border: 0;
  outline: 0;
  color: #334155;
  background: transparent;
  font-size: 11px;
  font-weight: 600;
}

.ops-node-type {
  display: flex;
  height: 40px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.ops-node-type > span {
  padding: 0 10px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.ops-node-type button {
  min-width: 50px;
  height: 32px;
  margin-right: 3px;
  border-radius: 6px;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.ops-node-type button.is-active {
  color: #fff;
  background: #4f46e5;
  box-shadow: 0 2px 5px rgba(79, 70, 229, 0.2);
}

.ops-search-field {
  position: relative;
  display: flex;
  min-width: 190px;
  height: 40px;
  flex: 1 1 220px;
  align-items: center;
}

.ops-search-field i {
  position: absolute;
  left: 12px;
  color: #64748b;
  font-size: 17px;
}

.ops-search-field input {
  width: 100%;
  height: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 12px 0 36px;
  color: #334155;
  outline: 0;
  font-size: 11px;
}

.ops-filter-field:focus-within,
.ops-search-field input:focus {
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.ops-monitor-state {
  min-width: 200px;
  margin-left: auto;
  color: #dc2626;
  text-align: right;
}

.ops-monitor-state > div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  font-size: 10px;
}

.ops-monitor-state b {
  color: #334155;
}

.ops-monitor-state small {
  display: block;
  margin-top: 3px;
  color: #64748b;
  font-size: 9px;
}

.ops-monitor-state .ops-status-dot {
  background: #ef4444;
}

.ops-monitor-state.is-connected {
  color: #16a34a;
}

.ops-monitor-state.is-connected .ops-status-dot {
  background: #16a34a;
}

.ops-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
}

.ops-alert.is-error {
  border: 1px solid #fecaca;
  color: #b91c1c;
  background: #fef2f2;
}

.ops-loading-state,
.ops-empty-state {
  display: flex;
  min-height: 420px;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  text-align: center;
}

.ops-loading-state i,
.ops-empty-state > i {
  margin-bottom: 10px;
  font-size: 34px;
}

.ops-empty-state h2 {
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.ops-empty-state p,
.ops-loading-state p {
  margin-top: 5px;
  font-size: 11px;
}

.ops-zone-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(235px, 1fr));
  gap: 10px;
}

.ops-zone-card {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  padding: 13px;
  text-align: left;
  transition: 0.15s ease;
}

.ops-zone-card:hover,
.ops-zone-card.is-selected {
  border-color: #818cf8;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.08);
}

.ops-card-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.ops-card-heading strong {
  display: block;
  color: #18181b;
  font-size: 13px;
}

.ops-card-heading small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 10px;
}

.ops-card-heading > i {
  color: #4f46e5;
  font-size: 18px;
}

.ops-status-bar {
  display: flex;
  height: 6px;
  overflow: hidden;
  margin: 12px 0 10px;
  border-radius: 999px;
  background: #e2e8f0;
}

.ops-status-bar.is-large {
  height: 8px;
}

.ops-status-bar span {
  min-width: 0;
}

.ops-status-bar .is-normal,
.ops-state-dot.is-normal,
.ops-mini-map span.is-normal,
.ops-mini-racks span.is-normal {
  background: #16a34a;
}

.ops-status-bar .is-warning,
.ops-state-dot.is-warning,
.ops-mini-map span.is-warning,
.ops-mini-racks span.is-warning {
  background: #f59e0b;
}

.ops-status-bar .is-critical,
.ops-state-dot.is-critical,
.ops-mini-map span.is-critical,
.ops-mini-racks span.is-critical {
  background: #ef4444;
}

.ops-status-bar .is-unavailable,
.ops-state-dot.is-unavailable,
.ops-mini-map span.is-unavailable,
.ops-mini-racks span.is-unavailable {
  background: #94a3b8;
}

.ops-count-row,
.ops-rack-counts {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  font-size: 9px;
}

.ops-count-row span,
.ops-rack-counts span {
  min-width: 0;
  white-space: nowrap;
}

.is-normal {
  color: #16a34a !important;
}

.is-warning {
  color: #d97706 !important;
}

.is-critical {
  color: #dc2626 !important;
}

.is-unavailable {
  color: #64748b !important;
}

.ops-zone-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 11px;
  color: #475569;
  font-size: 9px;
}

.ops-overview-layout {
  display: grid;
  grid-template-columns: 195px minmax(0, 1fr) 225px;
  gap: 10px;
  align-items: start;
}

.ops-panel {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.025);
}

.ops-panel-title,
.ops-results-header,
.ops-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ops-panel-title {
  min-height: 42px;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 11px;
}

.ops-panel-title span {
  border-radius: 5px;
  padding: 2px 6px;
  color: #4f46e5;
  background: #eef2ff;
  font-size: 9px;
}

.ops-panel-title small {
  color: #94a3b8;
  font-size: 8px;
  font-weight: 500;
}

.ops-zone-select {
  display: block;
  padding: 10px;
  border-bottom: 1px solid #f1f5f9;
}

.ops-zone-select select {
  width: 100%;
  height: 34px;
  margin-top: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  padding: 0 8px;
  outline: 0;
  color: #334155;
  background: #fff;
  font-size: 10px;
}

.ops-tree {
  max-height: 590px;
  overflow: auto;
  padding: 7px;
}

.ops-tree-zone {
  display: flex;
  width: 100%;
  height: 34px;
  align-items: center;
  gap: 5px;
  border-radius: 7px;
  padding: 0 7px;
  color: #4338ca;
  font-size: 10px;
  font-weight: 700;
}

.ops-tree-zone:hover {
  background: #eef2ff;
}

.ops-tree-zone span {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.ops-tree-zone b {
  border-radius: 999px;
  padding: 1px 6px;
  color: #4338ca;
  background: #eef2ff;
  font-size: 9px;
}

.ops-tree-racks {
  position: relative;
  margin: 1px 0 5px 13px;
  padding-left: 8px;
  border-left: 1px solid #e0e7ff;
}

.ops-tree-racks button {
  display: flex;
  width: 100%;
  height: 29px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 0 6px;
  color: #64748b;
  font-size: 9px;
}

.ops-tree-racks button:hover,
.ops-tree-racks button.is-selected {
  color: #4338ca;
  background: #f5f3ff;
}

.ops-tree-racks button span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.ops-state-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  flex: none;
  border-radius: 999px;
}

.ops-rack-results {
  min-width: 0;
  overflow: hidden;
}

.ops-results-header {
  min-height: 48px;
  padding: 9px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.ops-results-header strong,
.ops-results-header small {
  display: block;
}

.ops-results-header strong {
  font-size: 12px;
}

.ops-results-header small {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
}

.ops-pager {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #475569;
  font-size: 9px;
}

.ops-pager select,
.ops-pager button {
  height: 30px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
}

.ops-pager select {
  padding: 0 7px;
}

.ops-pager button {
  width: 30px;
}

.ops-pager button:disabled {
  opacity: 0.4;
}

.ops-rack-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  gap: 8px;
  transform-origin: top left;
  padding: 9px;
}

.ops-rack-card-grid.is-list {
  grid-template-columns: 1fr;
}

.ops-rack-card {
  min-width: 0;
  min-height: 150px;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 11px;
  background: #fff;
  transition: 0.15s ease;
}

.ops-rack-card:hover {
  border-color: #a5b4fc;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.ops-rack-card.is-selected {
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.12);
}

.ops-rack-card-top {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.ops-rack-card-top strong {
  color: #18181b;
  font-size: 11px;
}

.ops-rack-card-top > span:not(.ops-state-badge) {
  color: #4f46e5;
  font-size: 8px;
  font-weight: 700;
}

.ops-state-badge {
  padding: 3px 7px;
  color: #475569;
  background: #f8fafc;
  font-size: 8px;
}

.ops-state-badge.is-normal {
  color: #15803d !important;
  background: #f0fdf4;
}

.ops-state-badge.is-warning {
  color: #b45309 !important;
  background: #fffbeb;
}

.ops-state-badge.is-critical {
  color: #b91c1c !important;
  background: #fef2f2;
}

.ops-state-badge.is-unavailable {
  color: #64748b !important;
  background: #f1f5f9;
}

.ops-rack-card-top > button {
  margin-left: auto;
  color: #4f46e5;
  font-size: 8px;
  font-weight: 700;
}

.ops-rack-meta {
  display: flex;
  gap: 16px;
  margin-top: 9px;
  color: #64748b;
  font-size: 9px;
}

.ops-rack-meta b {
  margin-left: 3px;
  color: #0f172a;
}

.ops-rack-groups {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  margin-top: 8px;
  color: #64748b;
  font-size: 8px;
}

.ops-rack-groups b {
  color: #334155;
}

.ops-rack-groups span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-problem-count {
  margin-top: 7px;
  color: #dc2626;
  font-size: 8px;
  font-weight: 700;
}

.ops-overview-aside,
.ops-detail-aside {
  display: grid;
  gap: 9px;
}

.ops-summary-card,
.ops-affected-card,
.ops-mini-map-card,
.ops-legend,
.ops-selected-summary {
  padding-bottom: 10px;
}

.ops-summary-card > p,
.ops-selected-summary > p {
  padding: 12px 12px 0;
  font-size: 11px;
}

.ops-summary-card > p b,
.ops-selected-summary > p b {
  color: #dc2626;
  font-size: 18px;
}

.ops-summary-card > .ops-status-bar {
  margin-right: 12px;
  margin-left: 12px;
}

.ops-summary-card dl,
.ops-selected-summary dl,
.ops-drawer-section dl {
  margin: 6px 12px 0;
}

.ops-summary-card dl > div,
.ops-selected-summary dl > div,
.ops-drawer-section dl > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 25px;
  color: #64748b;
  font-size: 9px;
}

.ops-summary-card dd,
.ops-selected-summary dd,
.ops-drawer-section dd {
  color: #0f172a;
  font-weight: 700;
}

.ops-affected-card > button {
  display: flex;
  width: calc(100% - 16px);
  min-height: 34px;
  align-items: center;
  gap: 6px;
  margin: 5px 8px 0;
  border: 1px solid #f1f5f9;
  border-radius: 7px;
  padding: 0 8px;
  text-align: left;
}

.ops-affected-card > button:hover {
  border-color: #c7d2fe;
  background: #f8fafc;
}

.ops-affected-card b {
  flex: 1;
  font-size: 9px;
}

.ops-affected-card span {
  font-size: 8px;
  font-weight: 700;
}

.ops-muted {
  padding: 12px;
  color: #94a3b8;
  font-size: 9px;
}

.ops-mini-map {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(45px, 1fr));
  gap: 4px;
  min-height: 70px;
  margin: 8px;
  border: 6px solid #0f2740;
  border-radius: 7px;
  padding: 5px;
  background: #f8fafc;
}

.ops-mini-map > div {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-content: center;
  gap: 2px;
  border: 1px solid #e2e8f0;
  padding: 3px;
  opacity: 0.45;
}

.ops-mini-map > div.is-selected {
  border-color: #6366f1;
  opacity: 1;
}

.ops-mini-map span {
  width: 4px;
  height: 4px;
  border-radius: 99px;
}

.ops-mini-map-link {
  display: block;
  margin: 4px auto 0;
  color: #4f46e5;
  font-size: 9px;
  font-weight: 700;
}

.ops-legend {
  display: grid;
  gap: 7px;
  padding: 11px 12px;
}

.ops-legend strong {
  margin-bottom: 3px;
  font-size: 10px;
}

.ops-legend span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #64748b;
  font-size: 9px;
}

.ops-selected-swatch {
  width: 12px;
  height: 12px;
  border: 2px solid #4f46e5;
  border-radius: 3px;
}

.ops-selected-banner {
  margin-bottom: 11px;
  border: 1px solid #c7d2fe;
  border-radius: 9px;
  padding: 11px 13px;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.04);
}

.ops-selected-banner > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 9px;
  color: #475569;
  font-size: 10px;
}

.ops-selected-banner > div b {
  color: #4f46e5;
  font-size: 13px;
}

.ops-selected-banner > small {
  display: block;
  margin-top: 7px;
  color: #64748b;
  font-size: 9px;
}

.ops-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 225px;
  gap: 10px;
  align-items: start;
}

.ops-detail-main {
  min-width: 0;
  overflow: hidden;
}

.ops-physical-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(205px, 1fr));
  gap: 10px;
  padding: 10px;
  transform-origin: top left;
}

.ops-physical-rack {
  min-width: 0;
  cursor: pointer;
  border: 1px solid #dbe2ea;
  border-radius: 9px;
  background: #fff;
  overflow: hidden;
}

.ops-physical-rack.is-selected {
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.12);
}

.ops-physical-rack > header {
  padding: 10px;
  border-bottom: 1px solid #f1f5f9;
}

.ops-physical-rack > header > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.ops-physical-rack > header strong {
  font-size: 12px;
}

.ops-physical-rack > header p {
  margin-top: 6px;
  color: #475569;
  font-size: 8px;
  font-weight: 600;
}

.ops-rack-body {
  position: relative;
  height: 490px;
  margin: 9px 8px;
}

.ops-unit-labels {
  position: absolute;
  inset: 0 auto 0 0;
  width: 28px;
}

.ops-unit-labels span {
  position: absolute;
  right: 3px;
  color: #334155;
  font-size: 8px;
  font-weight: 700;
}

.ops-unit-track {
  position: absolute;
  inset: 0 0 0 29px;
  border: 1px solid #dbe2ea;
  border-radius: 5px;
  background-color: #f8fafc;
  background-image: repeating-linear-gradient(to top, transparent 0, transparent calc(2.380952381% - 1px), #e2e8f0 calc(2.380952381% - 1px), #e2e8f0 2.380952381%);
}

.ops-node-slot {
  position: absolute;
  right: 4px;
  left: 4px;
  display: flex;
  min-height: 15px;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  border: 1px solid #dcfce7;
  border-radius: 4px;
  padding: 0 5px;
  color: #334155 !important;
  background: #f0fdf4;
  font-size: 8px;
  line-height: 1;
  text-align: left;
  transition: 0.12s ease;
}

.ops-node-slot.is-warning {
  border-color: #fde68a;
  background: #fffbeb;
}

.ops-node-slot.is-critical {
  border-color: #fecaca;
  background: #fef2f2;
}

.ops-node-slot.is-unavailable {
  border-color: #e2e8f0;
  background: #f1f5f9;
}

.ops-node-slot:hover,
.ops-node-slot.is-selected {
  z-index: 2;
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.18);
}

.ops-node-slot > span {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}

.ops-node-slot em,
.ops-node-slot small {
  flex: none;
  border-radius: 4px;
  padding: 2px 4px;
  color: #dc2626;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.ops-node-slot small {
  color: #4338ca;
}

.ops-rack-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 9px;
}

.ops-rack-footer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  padding: 9px;
  border-top: 1px solid #f1f5f9;
}

.ops-rack-footer span {
  border-radius: 5px;
  padding: 5px 2px;
  background: #f8fafc;
  font-size: 8px;
  font-weight: 700;
  text-align: center;
}

.ops-selected-summary h3 {
  margin: 11px 12px 0;
  font-size: 11px;
  font-weight: 700;
}

.ops-mini-racks {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  margin: 9px;
  border: 6px solid #0f2740;
  border-radius: 7px;
  padding: 6px;
  background: #f8fafc;
}

.ops-mini-racks span {
  height: 58px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 3px;
  opacity: 0.35;
}

.ops-mini-racks span.is-selected {
  border-color: #312e81;
  opacity: 1;
}

.ops-detail-help {
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  padding: 10px;
  color: #4338ca;
  background: #eef2ff;
  font-size: 9px;
  line-height: 1.55;
}

.ops-node-tooltip {
  position: fixed;
  z-index: 130;
  width: 300px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.2);
  pointer-events: none;
}

.ops-tooltip-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-bottom: 1px solid #e2e8f0;
  color: #475569 !important;
  background: #f8fafc;
  font-size: 9px;
}

.ops-tooltip-title.is-normal {
  background: #f0fdf4;
}

.ops-tooltip-title.is-warning {
  background: #fffbeb;
}

.ops-tooltip-title.is-critical {
  background: #fef2f2;
}

.ops-tooltip-title b {
  display: flex;
  align-items: center;
  gap: 5px;
}

.ops-node-tooltip h3 {
  padding: 10px 12px 3px;
  font-size: 15px;
}

.ops-node-tooltip > p {
  padding: 1px 12px;
  color: #475569;
  font-size: 9px;
}

.ops-node-tooltip dl {
  margin: 8px 12px;
  padding: 7px 0;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.ops-node-tooltip dl > div {
  display: flex;
  justify-content: space-between;
  min-height: 22px;
  font-size: 9px;
}

.ops-node-tooltip dd {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
}

.ops-tooltip-problems {
  margin: 0 12px 7px;
}

.ops-tooltip-problems p {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  color: #475569;
  font-size: 8px;
}

.ops-node-tooltip > small {
  display: block;
  padding: 7px 12px;
  color: #4f46e5;
  background: #f8fafc;
  font-size: 9px;
  font-weight: 700;
  text-align: center;
}

.ops-drawer-layer {
  position: fixed;
  inset: 0;
  z-index: 140;
}

.ops-drawer-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.18);
}

.ops-monitor-drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  width: min(510px, 95vw);
  min-height: 0;
  flex-direction: column;
  background: #f8fafc;
  box-shadow: -12px 0 35px rgba(15, 23, 42, 0.18);
}

.ops-drawer-header {
  display: flex;
  min-height: 74px;
  flex: none;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.ops-drawer-header p {
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.ops-drawer-header h2 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  font-size: 17px;
  font-weight: 800;
}

.ops-drawer-header > button {
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #475569;
  font-size: 22px;
}

.ops-drawer-header > button:hover {
  background: #f1f5f9;
}

.ops-drawer-loading {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #64748b;
  font-size: 11px;
}

.ops-drawer-content {
  min-height: 0;
  flex: 1;
  overflow: auto;
  padding: 10px;
}

.ops-drawer-section {
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 11px;
  background: #fff;
}

.ops-drawer-section > h3,
.ops-section-heading h3 {
  font-size: 10px;
  font-weight: 800;
}

.ops-node-info dl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 18px;
  margin: 0;
}

.ops-mapping dl,
.ops-drawer-section > dl {
  margin: 7px 0 0;
}

.ops-section-heading > span {
  color: #dc2626;
  font-size: 8px;
  font-weight: 700;
}

.ops-section-heading > span.is-connected {
  color: #16a34a;
}

.ops-inline-notice {
  display: flex;
  gap: 5px;
  margin-top: 8px;
  border-radius: 6px;
  padding: 6px 8px;
  color: #475569;
  background: #f1f5f9;
  font-size: 8px;
}

.ops-current-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  margin-top: 8px;
}

.ops-current-grid > div {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  padding: 8px;
  text-align: center;
}

.ops-current-grid span,
.ops-current-grid b {
  display: block;
}

.ops-current-grid span {
  color: #64748b;
  font-size: 8px;
}

.ops-current-grid b {
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0f172a;
  font-size: 9px;
}

.ops-link-button,
.ops-more-button {
  color: #4f46e5;
  font-size: 8px;
  font-weight: 700;
}

.ops-more-button {
  margin-left: 7px;
  font-size: 15px;
}

.ops-link-button:disabled {
  color: #94a3b8;
}

.ops-monitor-menu {
  position: absolute;
  top: 24px;
  right: 0;
  z-index: 2;
  width: 135px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.ops-monitor-menu button {
  display: block;
  width: 100%;
  padding: 8px 10px;
  text-align: left;
  color: #334155;
  font-size: 9px;
}

.ops-monitor-menu button:hover {
  background: #f8fafc;
}

.ops-metric-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-top: 8px;
}

.ops-metric-grid article {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  padding: 7px;
  color: #334155 !important;
}

.ops-metric-grid article > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #64748b;
  font-size: 7px;
}

.ops-metric-grid article > b {
  display: block;
  margin-top: 4px;
  color: currentColor;
  font-size: 13px;
}

.ops-metric-grid article.is-warning > b {
  color: #d97706;
}

.ops-metric-grid article.is-critical > b {
  color: #dc2626;
}

.ops-metric-grid svg {
  width: 100%;
  height: 26px;
  margin-top: 3px;
  color: #6366f1;
}

.ops-metric-grid article.is-warning svg {
  color: #f59e0b;
}

.ops-metric-grid article.is-critical svg {
  color: #ef4444;
}

.ops-metric-grid article > button {
  display: block;
  margin: 3px auto 0;
  color: #4f46e5;
  font-size: 7px;
  font-weight: 700;
}

.ops-metric-grid article > button:disabled {
  color: #94a3b8;
}

.ops-problem-list {
  margin-top: 7px;
}

.ops-problem-list > button {
  display: grid;
  width: 100%;
  grid-template-columns: 8px minmax(0, 1fr) auto 12px;
  gap: 7px;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  padding: 8px 2px;
  text-align: left;
}

.ops-problem-list > button:first-child {
  border-top: 0;
}

.ops-problem-list span b,
.ops-problem-list span small {
  display: block;
}

.ops-problem-list span b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
  font-size: 9px;
}

.ops-problem-list span small,
.ops-problem-list em {
  margin-top: 2px;
  color: #64748b;
  font-size: 7px;
  font-style: normal;
}

.ops-problem-list > button > i:last-child {
  color: #4f46e5;
}

.ops-drawer-footer {
  display: grid;
  flex: none;
  grid-template-columns: 1fr 1.2fr;
  gap: 8px;
  padding: 10px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

.ops-drawer-footer button {
  height: 40px;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  color: #4f46e5;
  background: #fff;
  font-size: 10px;
  font-weight: 800;
}

.ops-drawer-footer button.is-primary {
  border-color: #4f46e5;
  color: #fff;
  background: #4f46e5;
}

.ops-drawer-footer button:disabled {
  border-color: #cbd5e1;
  color: #94a3b8;
  background: #e2e8f0;
}

@media (max-width: 1450px) {
  .ops-filter-field {
    min-width: 140px;
  }
  .ops-overview-layout {
    grid-template-columns: 175px minmax(0, 1fr) 205px;
  }
  .ops-physical-grid {
    grid-template-columns: repeat(4, minmax(185px, 1fr));
  }
}
@media (max-width: 1180px) {
  .ops-page-header {
    flex-direction: column;
  }
  .ops-header-actions {
    justify-content: flex-start;
  }
  .ops-monitor-state {
    width: 100%;
    margin-left: 0;
    text-align: left;
  }
  .ops-monitor-state > div {
    justify-content: flex-start;
  }
  .ops-overview-layout,
  .ops-detail-layout {
    grid-template-columns: 1fr;
  }
  .ops-navigator {
    display: none;
  }
  .ops-overview-aside,
  .ops-detail-aside {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 820px) {
  .operations-rack-view {
    padding: 12px;
  }
  .ops-physical-grid {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
  .ops-overview-aside,
  .ops-detail-aside,
  .ops-metric-grid {
    grid-template-columns: 1fr 1fr;
  }
}`],
})
export class PageKieraOperationsRackComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public errorMessage: string = '';
    public mode: 'overview' | 'detail' = 'overview';
    public displayMode: 'grid' | 'list' = 'grid';
    public zoomPercent: number = 100;
    public affectedOnly: boolean = false;

    public clusterFilter: number = 0;
    public groupFilter: string = 'all';
    public relayFilter: number = 0;
    public zoneFilter: number = -1;
    public nodeTypeFilter: 'all' | 'relay' | 'compute' = 'all';
    public searchText: string = '';

    public clusters: any[] = [];
    public groups: any[] = [];
    public relays: any[] = [];
    public zones: any[] = [];
    public navigatorZones: any[] = [];
    public racks: any[] = [];
    public allRacks: any[] = [];
    public summary: any = {};
    public overallSummary: any = {};
    public monitoring: any = {};
    public canvas: any = {};
    public updatedAt: string = '';

    public selectedRackId: number = 0;
    public overviewPage: number = 1;
    public overviewPageSize: number = 20;
    public navigatorExpanded: { [key: string]: boolean } = {};

    public hoveredNode: any = null;
    public tooltipStyle: any = {};
    public drawerOpen: boolean = false;
    public drawerLoading: boolean = false;
    public drawerError: string = '';
    public drawerData: any = null;
    public monitoringMenuOpen: boolean = false;
    public selectedNodeId: number = 0;

    private searchTimer: any = null;
    private initialRackId: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        this.mode = params.get('mode') === 'detail' ? 'detail' : 'overview';
        this.initialRackId = Number(params.get('rack') || 0);
        await this.load();
    }

    public ngOnDestroy() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
    }

    public async load(resetPage: boolean = false) {
        if (resetPage) this.overviewPage = 1;
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load', {
                cluster_id: this.clusterFilter,
                group_key: this.groupFilter,
                relay_node_id: this.relayFilter,
                zone_id: this.zoneFilter,
                node_type: this.nodeTypeFilter,
                text: this.searchText.trim(),
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '운영 Rack View를 불러오지 못했습니다.';
                return;
            }
            this.clusters = data?.clusters || [];
            this.groups = data?.groups || [];
            this.relays = data?.relay_options || [];
            this.zones = data?.zones || [];
            this.navigatorZones = data?.navigator_zones || [];
            this.racks = data?.racks || [];
            this.allRacks = data?.all_racks || this.racks;
            this.summary = data?.summary || {};
            this.overallSummary = data?.overall_summary || this.summary;
            this.monitoring = data?.monitoring || {};
            this.canvas = data?.canvas || {};
            this.updatedAt = data?.updated_at || '';
            this.zoneFilter = Number(data?.selected_zone_id ?? this.zoneFilter);
            this.groupFilter = String(data?.selected_group_key || this.groupFilter || 'all');
            for (const zone of this.navigatorZones) {
                const key = String(zone?.id ?? 0);
                if (this.navigatorExpanded[key] === undefined) this.navigatorExpanded[key] = true;
            }
            const requestedRackId = this.initialRackId || this.selectedRackId;
            const requestedRack = this.allRacks.find((rack: any) => Number(rack?.id) === Number(requestedRackId));
            if (requestedRack) {
                this.selectedRackId = Number(requestedRack.id);
            } else {
                const firstAffected = this.racks.find((rack: any) => rack?.state !== 'normal');
                this.selectedRackId = Number(firstAffected?.id || this.racks[0]?.id || 0);
            }
            this.initialRackId = 0;
        } catch (error) {
            this.errorMessage = '운영 Rack View 데이터를 불러오는 중 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public scheduleSearch() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.load(true), 350);
    }

    public async onFilterChanged() {
        if (!this.filteredGroups.some((item: any) => item.key === this.groupFilter)) {
            this.groupFilter = 'all';
        }
        if (!this.filteredRelays.some((item: any) => Number(item.id) === Number(this.relayFilter))) {
            this.relayFilter = 0;
        }
        await this.load(true);
    }

    public async setNodeTypeFilter(value: 'all' | 'relay' | 'compute') {
        if (value === this.nodeTypeFilter) return;
        this.nodeTypeFilter = value;
        await this.load(true);
    }

    public async selectZone(zone: any) {
        this.zoneFilter = Number(zone?.id ?? -1);
        await this.load(true);
    }

    public async openNavigatorRack(zone: any, rack: any) {
        this.zoneFilter = Number(zone?.id ?? -1);
        this.selectedRackId = Number(rack?.id || 0);
        this.mode = 'detail';
        await this.load(true);
    }

    public async selectRack(rack: any, detail: boolean = false) {
        this.selectedRackId = Number(rack?.id || 0);
        if (detail) this.mode = 'detail';
        await this.service.render();
    }

    public async switchMode(mode: 'overview' | 'detail') {
        this.mode = mode;
        if (mode === 'detail' && !this.selectedRackId) {
            this.selectedRackId = Number(this.racks[0]?.id || 0);
        }
        await this.service.render();
    }

    public async refresh() {
        await this.load(false);
    }

    public async toggleAffectedOnly() {
        this.affectedOnly = !this.affectedOnly;
        this.overviewPage = 1;
        await this.service.render();
    }

    public async setDisplayMode(mode: 'grid' | 'list') {
        this.displayMode = mode;
        await this.service.render();
    }

    public async zoom(delta: number) {
        this.zoomPercent = Math.max(70, Math.min(140, this.zoomPercent + delta));
        await this.service.render();
    }

    public async fitView() {
        this.zoomPercent = 100;
        await this.service.render();
    }

    public async openRackManagement() {
        this.service.href('/kiera/zones');
    }

    public get filteredGroups(): any[] {
        if (this.clusterFilter <= 0) return this.groups;
        return this.groups.filter((item: any) => (
            (item.cluster_ids || []).map(Number).includes(Number(this.clusterFilter))
        ));
    }

    public get filteredClusters(): any[] {
        if (this.groupFilter === 'all') return this.clusters;
        const group = this.groups.find((item: any) => item.key === this.groupFilter);
        const clusterIds = (group?.cluster_ids || []).map(Number);
        return this.clusters.filter((item: any) => clusterIds.includes(Number(item.id)));
    }

    public get filteredRelays(): any[] {
        return this.relays.filter((item: any) => {
            const clusterMatch = this.clusterFilter <= 0 || (item.cluster_ids || []).map(Number).includes(Number(this.clusterFilter));
            const groupMatch = this.groupFilter === 'all' || (item.group_keys || []).includes(this.groupFilter);
            return clusterMatch && groupMatch;
        });
    }

    public get selectedRack(): any {
        return this.allRacks.find((rack: any) => Number(rack?.id) === Number(this.selectedRackId)) || this.racks[0] || null;
    }

    public get affectedRacks(): any[] {
        return [...this.allRacks]
            .filter((rack: any) => rack?.state !== 'normal')
            .sort((a: any, b: any) => this.stateRank(b.state) - this.stateRank(a.state) || Number(b.active_problem_count || 0) - Number(a.active_problem_count || 0));
    }

    public get overviewSourceRacks(): any[] {
        return this.affectedOnly ? this.racks.filter((rack: any) => rack?.state !== 'normal') : this.racks;
    }

    public get overviewTotalPages(): number {
        return Math.max(1, Math.ceil(this.overviewSourceRacks.length / this.overviewPageSize));
    }

    public get overviewRacks(): any[] {
        const start = (this.overviewPage - 1) * this.overviewPageSize;
        return this.overviewSourceRacks.slice(start, start + this.overviewPageSize);
    }

    public get selectedZoneName(): string {
        if (this.zoneFilter === -1) return '전체 Zone';
        return this.zones.find((zone: any) => Number(zone?.id) === Number(this.zoneFilter))?.name || '선택 Zone';
    }

    public async setOverviewPage(page: number) {
        this.overviewPage = Math.max(1, Math.min(this.overviewTotalPages, Number(page || 1)));
        await this.service.render();
    }

    public get detailRacks(): any[] {
        const selected = this.selectedRack;
        if (!selected) return [];
        const sameZone = this.allRacks.filter((rack: any) => Number(rack?.zone_id) === Number(selected.zone_id));
        const index = Math.max(0, sameZone.findIndex((rack: any) => Number(rack.id) === Number(selected.id)));
        const start = Math.max(0, Math.min(index - 3, sameZone.length - 4));
        return sameZone.slice(start, start + 4);
    }

    public get detailNeighborCount(): number {
        return Math.max(0, this.detailRacks.length - 1);
    }

    public navigatorRacksFor(zoneId: any): any[] {
        return this.navigatorZones.find((zone: any) => Number(zone?.id) === Number(zoneId))?.racks || [];
    }

    public navigatorRackCount(): number {
        return this.navigatorZones.reduce((total: number, zone: any) => total + Number((zone.racks || []).length), 0);
    }

    public async toggleNavigatorZone(zone: any) {
        const key = String(zone?.id ?? 0);
        this.navigatorExpanded[key] = !this.navigatorExpanded[key];
        await this.service.render();
    }

    public isNavigatorExpanded(zone: any): boolean {
        return this.navigatorExpanded[String(zone?.id ?? 0)] !== false;
    }

    public stateRank(state: string): number {
        return ({ critical: 4, warning: 3, unavailable: 2, normal: 1 } as any)[state] || 0;
    }

    public stateLabel(state: string): string {
        return ({ normal: '정상', warning: '경고', critical: '심각', unavailable: '수집 불가', delayed: '지연', unknown: '판단 불가' } as any)[state] || '판단 불가';
    }

    public stateClass(state: string): string {
        return `is-${['normal', 'warning', 'critical', 'unavailable'].includes(state) ? state : 'unavailable'}`;
    }

    public stateColor(state: string): string {
        return ({ normal: '#16a34a', warning: '#f59e0b', critical: '#ef4444', unavailable: '#94a3b8' } as any)[state] || '#94a3b8';
    }

    public statusSegments(item: any): any[] {
        const counts = item?.counts || {};
        return ['normal', 'warning', 'critical', 'unavailable'].map((key: string) => ({
            key,
            value: Number(counts[key] || 0),
        }));
    }

    public segmentWidth(segment: any, item: any): number {
        const total = Number(item?.counts?.total || item?.node_count || 0);
        return total > 0 ? Number(segment?.value || 0) / total * 100 : 0;
    }

    public statusPercent(item: any, key: string): number {
        const total = Number(item?.counts?.total || item?.node_count || 0);
        return total > 0 ? Math.round(Number(item?.counts?.[key] || 0) / total * 1000) / 10 : 0;
    }

    public placedNodes(rack: any): any[] {
        return (rack?.nodes || []).filter((node: any) => Number(node?.unit || 0) > 0);
    }

    public rackUnitLabels(rack: any): number[] {
        const capacity = Number(rack?.capacity_u || 42);
        const values: number[] = [];
        for (let unit = capacity; unit >= 1; unit -= 6) values.push(unit);
        if (!values.includes(1)) values.push(1);
        return values;
    }

    public rackUnitLabelStyle(unit: number, rack: any): any {
        const capacity = Math.max(1, Number(rack?.capacity_u || 42));
        return { bottom: `calc(${Math.max(0, unit - 1) / capacity * 100}% - 6px)` };
    }

    public rackNodeStyle(node: any, rack: any): any {
        const capacity = Math.max(1, Number(rack?.capacity_u || 42));
        const unit = Math.max(1, Number(node?.unit || 1));
        const size = Math.max(1, Number(node?.unit_size || 1));
        return {
            bottom: `${(unit - 1) / capacity * 100}%`,
            height: `max(16px, calc(${Math.min(size, capacity) / capacity * 100}% - 2px))`,
        };
    }

    public trackRack(_index: number, rack: any): number {
        return Number(rack?.id || 0);
    }

    public trackNode(_index: number, node: any): number {
        return Number(node?.id || 0);
    }

    public async onNodeHover(event: MouseEvent, node: any, rack: any) {
        const width = 300;
        const left = Math.min(window.innerWidth - width - 16, event.clientX + 16);
        const top = Math.min(window.innerHeight - 330, Math.max(12, event.clientY - 50));
        this.hoveredNode = { ...node, rack_name: rack?.name, zone_name: rack?.zone_name };
        this.tooltipStyle = { left: `${Math.max(12, left)}px`, top: `${top}px` };
        await this.service.render();
    }

    public async onNodeHoverMove(event: MouseEvent) {
        if (!this.hoveredNode) return;
        const width = 300;
        this.tooltipStyle = {
            left: `${Math.max(12, Math.min(window.innerWidth - width - 16, event.clientX + 16))}px`,
            top: `${Math.max(12, Math.min(window.innerHeight - 330, event.clientY - 50))}px`,
        };
        await this.service.render();
    }

    public async onNodeHoverLeave() {
        this.hoveredNode = null;
        await this.service.render();
    }

    public async openNode(node: any) {
        if (!node?.id) return;
        this.selectedNodeId = Number(node.id);
        this.drawerOpen = true;
        this.drawerLoading = true;
        this.drawerError = '';
        this.drawerData = null;
        this.monitoringMenuOpen = false;
        this.hoveredNode = null;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('node_detail', { node_id: node.id });
            if (code !== 200) {
                this.drawerError = data?.message || '노드 Monitoring 요약을 불러오지 못했습니다.';
            } else {
                this.drawerData = data;
            }
        } catch (error) {
            this.drawerError = '노드 Monitoring 요약을 불러오는 중 오류가 발생했습니다.';
        } finally {
            this.drawerLoading = false;
            await this.service.render();
        }
    }

    public async closeDrawer() {
        this.drawerOpen = false;
        this.monitoringMenuOpen = false;
        await this.service.render();
    }

    public monitoringDisabledReason(): string {
        if (!this.drawerData?.monitoring?.connected) return this.drawerData?.monitoring?.reason || 'Monitoring Service에 연결할 수 없습니다.';
        if (!this.drawerData?.mapping?.mapped) return 'Monitoring Host 매핑이 필요합니다.';
        if (!this.service.auth.can('zabbix', 'read')) return 'Monitoring 상세 조회 권한이 없습니다.';
        return '';
    }

    public monitoringRoute(target: string): string {
        const node = this.drawerData?.node || {};
        const params = new URLSearchParams();
        params.set('target', target || '');
        params.set('return', `/kiera/operations-rack?mode=detail&rack=${this.selectedRackId}`);
        params.set('host', node.name || '');
        params.set('hostid', this.drawerData?.mapping?.external_host_id || '');
        params.set('rack', node.rack_name || '');
        return `/kiera/zabbix?${params.toString()}`;
    }

    public async openMonitoring(target: string, newTab: boolean = false) {
        const reason = this.monitoringDisabledReason();
        if (reason || !target) {
            await this.service.modal.warning(reason || '연결할 Monitoring 화면이 없습니다.', false, '확인');
            return;
        }
        const url = this.monitoringRoute(target);
        if (newTab) {
            const tab = window.open(url, '_blank', 'noopener,noreferrer');
            if (tab) tab.opener = null;
            return;
        }
        this.service.href(url);
    }

    public openNodeEvents() {
        const nodeId = Number(this.drawerData?.node?.id || 0);
        if (nodeId > 0) this.service.href(`/kiera/nodes/${nodeId}/timeline`);
    }

    public async toggleMonitoringMenu() {
        this.monitoringMenuOpen = !this.monitoringMenuOpen;
        await this.service.render();
    }

    public sparklinePoints(points: any[]): string {
        const values = (points || []).map(Number).filter((value: number) => Number.isFinite(value));
        if (values.length < 2) return '0,22 100,22';
        const min = Math.min(...values);
        const max = Math.max(...values);
        const range = max - min || 1;
        return values.map((value: number, index: number) => {
            const x = index / (values.length - 1) * 100;
            const y = 26 - (value - min) / range * 22;
            return `${x.toFixed(1)},${y.toFixed(1)}`;
        }).join(' ');
    }

    public severityLabel(severity: any): string {
        const value = Number(severity || 0);
        if (value >= 4) return '심각';
        if (value >= 2) return '경고';
        return '정보';
    }

    public severityClass(severity: any): string {
        const value = Number(severity || 0);
        return value >= 4 ? 'is-critical' : value >= 2 ? 'is-warning' : 'is-unavailable';
    }

    public formatDate(value: any): string {
        if (!value) return '-';
        const date = typeof value === 'number' || /^\d+$/.test(String(value))
            ? new Date(Number(value) * 1000)
            : new Date(String(value));
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString();
    }

    public durationFrom(clock: any): string {
        const seconds = Math.max(0, Math.floor(Date.now() / 1000) - Number(clock || 0));
        if (seconds < 60) return `${seconds}초`;
        if (seconds < 3600) return `${Math.floor(seconds / 60)}분`;
        if (seconds < 86400) return `${Math.floor(seconds / 3600)}시간`;
        return `${Math.floor(seconds / 86400)}일`;
    }
}

export default PageKieraOperationsRackComponent;
